import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import axios from "axios";
import rehypeRaw from "rehype-raw";
import remarkDirective from "remark-directive";
import { remarkCenterDirective } from "../components/remarkCenterDirective";
import { useAuth } from "../components/AuthContext";

function preprocessAdvancedOrderedLists(markdown) {
    const lines = markdown.split("\n");
    const output = [];
    let insideMainList = false;
    let insideNestedList = false;
    let nestedBuffer = [];

    const closeNested = () => {
        if (insideNestedList) {
            output.push('<ol type="1">');
            output.push(...nestedBuffer.map(text => `<li>${text}</li>`));
            output.push('</ol>');
            output.push('</li>'); // close parent li
            insideNestedList = false;
            nestedBuffer = [];
        }
    };

    const closeMain = () => {
        if (insideMainList) {
            if (!insideNestedList) {
                output.push('</li>'); // close last main <li> if it didn’t have a nested list
            }
            output.push('</ol>');
            insideMainList = false;
        }
    };

    for (let i = 0; i < lines.length; i++) {
        const line = lines[i];

        const mainMatch = /^([A-Z])\. (.+)/.exec(line);
        const nestedMatch = /^\s+[A-Z]\.(\d+)\. (.+)/.exec(line);

        if (mainMatch) {
            closeNested();
            if (!insideMainList) {
                output.push('<ol type="A">');
                insideMainList = true;
            }
            output.push(`<li>${mainMatch[2]}`);
        } else if (nestedMatch) {
            if (!insideNestedList) {
                insideNestedList = true;
                nestedBuffer = [];
            }
            nestedBuffer.push(nestedMatch[2]);
        } else {
            // Normal text line (not list)
            closeNested();
            closeMain();
            output.push(line);
        }
    }

    // Close any remaining open tags
    closeNested();
    closeMain();

    return output.join("\n");
}



export default function DynamicMemberPage() {
    const pathname = useLocation().pathname.replace(/^\//, "");
    const [doc, setDoc] = useState(null);
    const [loading, setLoading] = useState(true);
    const { authToken } = useAuth();

    useEffect(() => {
        setLoading(true);
        // Try localStorage first, then context
        const token = localStorage.getItem("auth_token") || authToken;
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        
        axios.get(`/api/member-content/${encodeURIComponent(pathname)}`, { headers })
            .then(r => setDoc(r.data))
            .catch(() => setDoc(null))
            .finally(() => setLoading(false));
    }, [pathname, authToken]);

    if (loading) return <p className="text-center mt-5">Loading…</p>;
    if (!doc) return <></>;

    return (
        <div className="container py-3">
            <div className="row justify-content-center">
                <h2 className="text-center">{doc.title}</h2>
            </div>
            <div className={`container member-markdown-body`} style={{ maxWidth: 800 }}>
                <ReactMarkdown
                    children={preprocessAdvancedOrderedLists(doc.markdown)}
                    rehypePlugins={[rehypeRaw]}
                    remarkPlugins={[remarkDirective, remarkCenterDirective]}
                />
            </div>
        </div>
    );

}